import { eTipoPermissao } from '@/enums/ePermissoes';

export default [
 {
  description: 'Alocação de Patrimônio',
  path: '/patrimonio/patalocacao',
  name: 'patalocacao',
  component: () => import('@/views/patrimonio/patalocacao/Index.vue'),
  meta: {
   permissions: [eTipoPermissao.ALOCACAODETIPODEBENSNOVO_MENU_1200200199],
  },
  goesToMenu: true,
 },
]
